import React from 'react'
import ClientUserAnalytics from './ClientUserAnalytics';
import ClientAnalytics from './ClientAnalytics';
import { AdminPage, ViewSwitch, useViewParam } from './AdminAnalyticsUI';

const VIEWS = [
  { key: 'analytics', label: 'Clients analytics' },
  { key: 'list', label: 'Clients list' },
];

function AnalyticsClient({setActivePanel, activePanel}) {
  const [view, setView] = useViewParam();
  return (
    <AdminPage setActivePanel={setActivePanel} activePanel={activePanel}>
      <div style={{ marginBottom: '26px' }}>
        <ViewSwitch options={VIEWS} value={view} onChange={setView} />
      </div>
      {view === 'analytics' ? <ClientAnalytics/> : <ClientUserAnalytics/>}
    </AdminPage>
  )
}

export default AnalyticsClient;
